module.exports = __webpack_public_path__ + "static/img/RAPHAEL-GEESU.3192a66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RAPHAEL-GEESU.jpg
// module id = JoaM
// module chunks = 0